import React from 'react';

export default function MicrositeProductTitle({ block, position }) {
  const { _metadata, heading, subheading } = block?.microsite_product_title;

  return (
    <section
      id={`${_metadata.uid}_${position}`}
      data-name="microsite-product-title"
    >
      <div className="mb-6">
        <div className="body-s preheading-s mb-2 text-white">{heading}</div>
        <div className="h4 font-normal text-white not-italic">{subheading}</div>
      </div>
    </section>
  );
}
